import { IDs } from '../../../helpers/IDs';
import { lazyInject } from '../../../services/inversify';
import * as React from 'react';
import { TriggerService } from '../../../core/trigger/trigger_service';
import { WFormsTableWrapper } from '../../../core/table/WFormsTableWrapper';

export interface DatenverwaltungGewerkeProps {
    dummy?: any;
}

export interface DatenverwaltungGewerkeState {
    dummy?: any;
}

export class DatenverwaltungGewerke extends React.Component<DatenverwaltungGewerkeProps, DatenverwaltungGewerkeState> {

    constructor(props: any) {
        super(props);
        this.state = {};
    }

    @lazyInject(TriggerService) private triggerService: TriggerService;

    componentWillUnmount() {
        this.setState = (state, callback) => {
            return;
        };
    }

    render(): JSX.Element {
         return (
            <div>
                <WFormsTableWrapper
                    entity={IDs.ENT_BRANCHEN_GEWERKE}
                    module={IDs.MOD_ETOOL_ADMIN}
                    actions={['add', 'edit', 'delete']}
                    customClass={'Custom-ETA'}
                    formLayout={'flowV2'}
                    onSaveDone={() => this.triggerService.fire('admin_reload', IDs.ENT_BRANCHEN_GEWERKE)}
                    showColumnsHelp={true}
                />
            </div>
        );
    }
}
